<span
  class="icon-inline"
  v-tooltip.bottom="tooltipOptions"
>
  <RapidSvg :style="svgStyle" />
</span>
